import getUsernameFromStore from './getUsernameFromStore';

function getRemoveItemFromCartEndpoint(store) {
  return `/cart/${getUsernameFromStore(store)}/delete-from-cart/`;
}

export default getRemoveItemFromCartEndpoint;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/getRemoveItemFromCartEndpoint.js